import React, { useEffect, useState } from "react";
import "./agentStatusUpdate.css";
import { Pagination } from "@mui/material";
import axios from "axios";
import { BaseUrl } from "../../container/BaseUrl/BaseUrl";
import { errorhandelApi } from "../../ApiCall/ErrorHandelApi";
import { errorHandel } from "../../ApiCall/LogoutApi";
import { RiErrorWarningLine } from "react-icons/ri";
import { setTeamactivitydashboardcount } from "../../redux/actions/actions";
import { connect } from "react-redux";
import { toast } from "react-toastify";

const mapStateToProps = (state) => {
  return {
    teamactivitydashboardcount: state.data.teamactivitydashboardcount,
  };
};

const AgentStatus = (props) => {
  const { teamactivitydashboardcount } = props;
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const agentId = JSON.parse(localStorage.getItem("tokenAgent"));
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [userstatus, setUserstatus] = useState([]);

  const toggleDropdown = (agentId) => {
    setDropdownVisible((prevVisible) => !prevVisible && agentId);
    AgentDropDownList();
  };

  const AgentList = async () => {
    try {
      await axios
        .post(
          BaseUrl + "/dashboard/chatCount",
          {
            from_date: defaultValue,
            to_date: defaultValue,
            offset: page == 1 ? 0 : (page - 1) * 10,
            limit: 10,
            agent_id: agentId.agent_id,
            type: "webstatics",
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            props.setTeamactivitydashboardcount(res.data.Data);
            setPagination(res.data.count);
          } else {
            props.setTeamactivitydashboardcount([]);
            setPagination(0);
          }
        });
    } catch (error) {
      errorhandelApi(error, "/dashboard/chatCount");
    }
  };

  const AgentDropDownList = async () => {
    try {
      await axios
        .post(
          BaseUrl + "/userstatus/userstatuslist",
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then(function (response) {
          const responseData = response.data.data;
          if (Array.isArray(responseData)) {
            setUserstatus(responseData);
          }
        });
    } catch (error) {
      errorHandel(error, "/userstatus/userstatuslist");
    }
  };

  const updateStatusApi = async (value, agentId) => {
    await axios
      .post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: value,
          userId: agentId.user_id,
          type: "statuschange",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        const updatedAgentList = teamactivitydashboardcount.map((client) => {
          if (client.agent_id.user_id === agentId.user_id) {
            return {
              ...client,
              agent_id: {
                ...client.agent_id,
                agent_status_real: value,
              },
            };
          }
          return client;
        });
        props.setTeamactivitydashboardcount(updatedAgentList);
      });
  };

  const LogoutAgent = (userid) => {
    try {
      axios
        .post(
          BaseUrl + `/users/logout/${userid}`,
          {
            type: "forcelogout",
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          console.log("LogoutAgent", res);
          if (res.data.success) {
            toast.success("Agent Logout successfully", {
              position: "top-right",
              autoClose: 500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
          }
        })
        .catch((err) => {
          console.log("LogoutAgent", err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    AgentList();
  }, [page]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      AgentList();
      setPage(page);
    }, 5000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <div className="container-fluid p-2">
        <div className="card fixed-table-card vh-79 agentStatus">
          <div className="card-body">
            <div>
              <p className="card-title">RealTime Agent</p>
            </div>

            <div
              className="table-responsive vhm-68 "
              style={{ height: "100%" }}
            >
              <table className="table table-sm table-hover align-middle table-fixeded">
                <thead>
                  <tr>
                    <th scope="col">Agent Name</th>
                    <th scope="col">Status</th>
                    <th scope="col">Logout</th>
                  </tr>
                </thead>

                <tbody>
                  {teamactivitydashboardcount.length > 0 ? (
                    teamactivitydashboardcount.map((rowData) => (
                      <tr key={rowData._id} className="text-break">
                        <td>
                          {rowData.agent_id == null ||
                          rowData.agent_id == undefined ||
                          rowData.agent_id == ""
                            ? "--"
                            : rowData.agent_id.username}
                        </td>
                        <td>
                          <div className="agentStatus-dropdown">
                            <div className="">
                              <button
                                id={`button-${rowData.agent_id.user_id}`}
                                className={`agentStatus-btn-dropdown dropdown-toggle ${
                                  rowData.agent_id.agent_status_real ===
                                    "Available" ||
                                  rowData.agent_id.agent_status_real === "Ready"
                                    ? "btn-success"
                                    : rowData.agent_id.agent_status_real ===
                                      "Connected"
                                    ? "btn-info"
                                    : "btn-warning"
                                }`}
                                type="button"
                                disabled={
                                  rowData.agent_id.agent_status_real ===
                                  "Is LoggedOut"
                                }
                                onClick={() => {
                                  toggleDropdown(rowData.agent_id.user_id);
                                }}
                              >
                                {rowData.agent_id.agent_status_real ===
                                  "Available" ||
                                rowData.agent_id.agent_status_real === "Ready"
                                  ? "Ready"
                                  : rowData.agent_id.agent_status_real}
                              </button>

                              <div
                                className="nav__item dropdown"
                                id="myDropdown"
                              >
                                {isDropdownVisible ===
                                  rowData.agent_id.user_id && (
                                  <div className="Status_dropdown__list">
                                    <div className="agentStatus-dropdown__item border-bottom">
                                      <div
                                        className="dropdown__link"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          updateStatusApi(
                                            "Ready",
                                            rowData.agent_id
                                          );
                                          setDropdownVisible();
                                        }}
                                      >
                                        Ready
                                      </div>
                                    </div>

                                    <div className="agentStatus-dropdown__item Status_submenu">
                                      <div
                                        className="dropdown__link"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          updateStatusApi(
                                            "Not Ready",
                                            rowData.agent_id
                                          );
                                          setDropdownVisible();
                                        }}
                                      >
                                        Not Ready &#x25B8;
                                      </div>

                                      <div className="Status_submenu__list">
                                        {Array.isArray(userstatus) &&
                                          userstatus.length > 0 &&
                                          userstatus.map(
                                            (statusData, index) => (
                                              <div
                                                key={index}
                                                className="Status_submenu__item border-bottom"
                                              >
                                                <div
                                                  className="submenu__link"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => {
                                                    updateStatusApi(
                                                      statusData.statusName,
                                                      rowData.agent_id
                                                    );
                                                    setDropdownVisible();
                                                  }}
                                                >
                                                  {statusData.statusName}
                                                </div>
                                              </div>
                                            )
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            disabled={
                              rowData.agent_id.agent_status_real ===
                              "Is LoggedOut"
                            }
                            onClick={() => {
                              LogoutAgent(rowData.agent_id.user_id);
                            }}
                          >
                            <i className="fa-solid fa-right-from-bracket"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr key="">
                      <td colSpan="15">
                        <div
                          className="text-muted"
                          style={{
                            flexDirection: "column",
                            marginTop: "20%",
                            display: "flex",
                            position: "absolute",
                            left: "45%",
                            bottom: "40%",
                          }}
                        >
                          <span className="mx-auto">
                            <RiErrorWarningLine size={30} />
                          </span>
                          <span className="mx-auto">
                            <h5
                              className="text-muted mt-2"
                              style={{
                                fontFamily: "poppins",
                              }}
                            >
                              No Data Found
                            </h5>
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}{" "}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="card-footer rounded-0 d-flex align-item-center justify-content-end align-items-center">
        <Pagination
          count={Math.ceil(pagination / 10)}
          page={page}
          color="primary"
          size="small"
          style={{ float: "right" }}
          onChange={handleChange}
        />
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setTeamactivitydashboardcount,
})(AgentStatus);
